import * as React from 'react';
import { CircularGauge } from '@progress/kendo-react-gauges';

const DialControl = ({name,value,color,...props}) => {
 const [valuee, setValuee] = React.useState(0);
  React.useEffect(() => {
    setValuee(value);
  }, [value]);
  const arcOptions = {
    value: valuee,
    color
  };
  const centerRenderer = (value, color) => {
    return <span style={{
      color: "#2D475C"
    }}>{name}</span>;
  };
  return <CircularGauge {...arcOptions} {...props} centerRender={centerRenderer} scale={{rangeSize:17}} />;
};
export default DialControl;